import { useLayoutEffect } from "react";
import useQuestions from "../../Hooks/useQuestions";
import { Link, useParams } from "react-router-dom";
import useUser from "../../Hooks/user";

const DeleteQues = () => {
  const user = useUser();
  const clientId = user.state.user.client;
  const { Delete } = useQuestions(clientId);
  const { id } = useParams();

  const DeleteInstance = (e) => {
    Delete(e);
  };

  useLayoutEffect(() => {
    document.title = "Delete";
  }, []);

  return (
    <div className="list-attempts">
      <div className="heading">
        <h6>Question Delete</h6>
        <hr />
      </div>
      <div className="dataDelete">
        <h6>Are you sure you want to delete this Question Instance?</h6>
        <Link to="/list-questions">
          <button type="button" class="btn btn-primary btn-sm">
            Cancel
          </button>
        </Link>
        &nbsp;&nbsp;
        <button
          type="button"
          class="btn btn-danger btn-sm"
          value={id}
          onClick={(e) => DeleteInstance(e.target.value)}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default DeleteQues;
